export default "__VITE_ASSET__a8b1f597__"